import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { LOAD_WASM, NgxScannerQrcodeModule } from "ngx-scanner-qrcode";
import { AsyncPipe, JsonPipe, NgClass } from "@angular/common";
import { QRCodeModule } from "angularx-qrcode";
// import {TranslocoPipe, TranslocoService} from "@jsverse/transloco";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2";
import { QrScannerModalComponent } from '../qr-scanner-modal/qr-scanner-modal.component';


// Necessary to solve the problem of losing internet connection
// LOAD_WASM().subscribe();

@Component({
  selector: 'app-qr-scanner',
  standalone: true,
  imports: [
    NgxScannerQrcodeModule,
    JsonPipe,
    AsyncPipe,
    QRCodeModule,
    NgClass,
    NgxScannerQrcodeModule
],
  providers:[NgbModal],
  templateUrl: './qr-scanner.component.html',
  styleUrl: './qr-scanner.component.scss'
})
export class QrScannerComponent {
  public modalService = inject(NgbModal);
  // public translocoService = inject(TranslocoService);
  @Output() scanResult = new EventEmitter<string>();

  @Input() btnPxWidth?: string;
  @Input() btnClasses?: string;
  @Input() modalSize: 'xl' | 'lg' | 'md' | 'sm' = 'md';

  defaultClasses = 'btn-primary rounded-end-2 px-0 d-flex justify-content-center'

  // constructor(private modalService:NgbModal){}

  openQrModal() {
    const qrModal = this.modalService.open(QrScannerModalComponent, { size: this.modalSize })
    qrModal.closed.subscribe((qrResult) => {
      this.manageResult(qrResult)
    })
  }

  manageResult(result: string) {

    result = this.formatTo0x(result);

    if (result && result.length == 42 && result.startsWith('0x')) {
      Swal.fire({
        icon: "success",
        showConfirmButton:false,
        text: '', //this.translocoService.translate('QR.import.swal.success'),
        confirmButtonText: '', //this.translocoService.translate('GENERIC.texts.okay')
        timer:1000
      })
      this.scanResult.emit(result)
    } else {
      Swal.fire({
        icon: "error",
        showConfirmButton:false,
        text: '',//this.translocoService.translate('QR.import.swal.error'),
        confirmButtonText: '', //this.translocoService.translate('GENERIC.texts.okay')
        timer:100
      })
    }
  }

  formatTo0x(input: string): string {
    // Check if the string already starts with '0x'
    if (input.startsWith('0x')) {
      return input;
    }
    // Find the index of the first occurrence of '0x' in the string
    const index = input.indexOf('0x');
    // If '0x' is found in the string
    if (index !== -1) {
      // Return the substring starting from the first occurrence of '0x'
      return input.substring(index);
    }
    return input;
  }
}
